import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { expandSelfClosingTags } from '@utils/common';
import { mediaSchema } from '../../media.js';
import { baseTaskSchema } from '../schema.base.js';
import { inlineAudioInput } from '../write-answers.in-text/input.inline-audio.js';
import { video23Input } from './parser.video.js';

const infoPageTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("InfoPage"),
  media: z.array(mediaSchema).default([]),
  text: z.string()
}).transform(({
  media,
  text,
  ...rest
}) => ({
  ...rest,
  content: xml2ast(expandSelfClosingTags(text), {
    ...allHtmlParsers,
    ...inlineAudioInput.parsers,
    ...video23Input.parsers
  }, "text/html", {
    context: {
      taskId: rest.id,
      media
    }
  })
}));

export { infoPageTaskSchema };
//# sourceMappingURL=_schema.js.map
